import { IconProps } from '../types';

function MeshEdgesOutlineIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className || 'h-6 w-6'}
    >
      {/* Outer hexagon representing a mesh object */}
      <path d="M12 2L21 7V17L12 22L3 17V7L12 2Z" />
      {/* Internal edges showing hard seams between mesh surfaces */}
      <path d="M12 2L3 17" strokeWidth="1" />
      <path d="M12 2L21 17" strokeWidth="1" />
    </svg>
  );
}

export default MeshEdgesOutlineIcon;
